(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[965],{

/***/ "h6Iw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NavigationLargeSubNavList", function() { return NavigationLargeSubNavList; });
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("z84I");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_string_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("hBvt");
/* harmony import */ var core_js_modules_es_string_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("zjfJ");
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("MwrP");
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lodash_isEmpty__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("C/y5");
/* harmony import */ var _Navigation_constants__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("1cDg");
/* harmony import */ var _tracking_tracking_api_useTracking__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("sRdV");
/* harmony import */ var _frameworks_dynamic_link_DynamicLink__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("i5Mr");




var __jsx = react__WEBPACK_IMPORTED_MODULE_4___default.a.createElement;





var NavigationLargeSubNavList = function NavigationLargeSubNavList(_ref) {
  var _ref$subItems = _ref.subItems,
      subItems = _ref$subItems === void 0 ? [] : _ref$subItems;
  var track = Object(_tracking_tracking_api_useTracking__WEBPACK_IMPORTED_MODULE_7__[/* useTracking */ "a"])();

  if (lodash_isEmpty__WEBPACK_IMPORTED_MODULE_3___default()(subItems)) {
    return null;
  }

  return __jsx("div", {
    className: "bg-white overflow-y-auto px-50 py-25 rounded-b",
    style: {
      maxHeight: _Navigation_constants__WEBPACK_IMPORTED_MODULE_6__[/* NAVIGATIONLARGE_SUBNAV_MAX_HEIGHT */ "a"]
    }
  }, __jsx("ul", {
    className: "columns-5 gap-50"
  }, subItems.map(function (item, index) {
    var _item$link2;

    return __jsx("li", {
      className: "break-inside-avoid-column ".concat(index ? 'my-15' : ''),
      "data-testid": "NavigationLargeSubNavList-sublist-item",
      key: item.label
    }, __jsx(_frameworks_dynamic_link_DynamicLink__WEBPACK_IMPORTED_MODULE_8__[/* default */ "a"], {
      className: Object(_utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_5__[/* classnames */ "a"])('font-bold font-sans text-black hocus:text-black-active text-16', "text-".concat(item.color), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"])({}, "hocus:text-".concat(item.color, "-active"), !!item.color)),
      "data-testid": "NavigationLargeSubNavList-sublist-link",
      onClick: function onClick() {
        var _item$link;

        return ((_item$link = item.link) === null || _item$link === void 0 ? void 0 : _item$link.trackingData) && track(item.link.trackingData);
      },
      url: (_item$link2 = item.link) === null || _item$link2 === void 0 ? void 0 : _item$link2.url
    }, item.label), !lodash_isEmpty__WEBPACK_IMPORTED_MODULE_3___default()(item.subItems) && __jsx("ul", {
      className: "mt-15 "
    }, (item.subItems || []).map(function (subItem) {
      var _subItem$link2;

      return __jsx("li", {
        key: subItem.label
      }, __jsx(_frameworks_dynamic_link_DynamicLink__WEBPACK_IMPORTED_MODULE_8__[/* default */ "a"], {
        className: "font-bold font-sans text-black hocus:text-black-active text-12",
        "data-testid": "NavigationLargeSubNavList-subsublist-link",
        onClick: function onClick() {
          var _subItem$link;

          return ((_subItem$link = subItem.link) === null || _subItem$link === void 0 ? void 0 : _subItem$link.trackingData) && track(subItem.link.trackingData);
        },
        url: (_subItem$link2 = subItem.link) === null || _subItem$link2 === void 0 ? void 0 : _subItem$link2.url
      }, subItem.label));
    })));
  })));
};

/***/ })

}]);